import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
    selector: 'cmn-hero',
    templateUrl: './hero.component.html',
    styleUrls: [ './hero.component.scss' ],
})

export class HeroComponent implements AfterViewInit {
    @Input() public readonly title: string;
    @Input() public readonly image: string;
    @Input() public readonly isGrid: boolean;
    @Input() public readonly subTitle: string;
    @Input() public readonly hasImgExtraSize: boolean;
    @Input() public readonly action: { label: string, style: string };
    @Input() public readonly alignment: 'centered' | 'left' | 'right';

    @Output('onInit') private readonly fireInit: EventEmitter<void> = new EventEmitter<void>();

    public ngAfterViewInit(): void {
        this.fireInit.emit();
    }
}
